import { render, staticRenderFns } from "./campusList.vue?vue&type=template&id=8133dcd6&scoped=true&"
import script from "./campusList.vue?vue&type=script&lang=js&"
export * from "./campusList.vue?vue&type=script&lang=js&"
import style0 from "./campusList.vue?vue&type=style&index=0&id=8133dcd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8133dcd6",
  null
  
)

export default component.exports